import locale from "localization";
import styles from "./shift-details-stock-inventory.module.scss";
import { Title } from "components/commons";
import {
  dryStockDeliveriesMapper,
  dryStockDeliveryProductsMapper,
} from "./shift-details-stock-inventory.mapper";
import {
  dryStockDeliveriesColumn,
  dryStockDeliveryProductsColumn,
} from "./shift-details-stock-inventory-column";
import { initialFilterState } from "modules/shift-records/shift-records-filter.state";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";

const ShiftDetailsDryStockDeliveries = ({ shift, allProducts }) => {
  const dryStockDeliveries = shift?.delivery.deliveries?.filter(
    (delivery) => delivery.productType !== "fuel",
  );

  const dryStockDeliveriesDataTable = useDataTable({
    value: dryStockDeliveries,
    filter: { initialState: initialFilterState(), mapper: (val) => val },
    table: {
      key: "delivery",
      name: "dryStockDeliveries",
      mapper: (val) => dryStockDeliveriesMapper({ val }),
      columns: dryStockDeliveriesColumn,
    },
  });

  const dryStockDeliveryIds = new Set(dryStockDeliveries?.map((d) => d.deliveryId) || []);

  const formattedDeliveryProducts = shift?.delivery.deliveryProducts
    ?.filter((dp) => dryStockDeliveryIds.has(dp.deliveryId))
    ?.map((delivery) => {
      const product = allProducts.find(
        (item) =>
          item.sku.toLowerCase().replace(/\s+/g, "") ===
          delivery.product.toLowerCase().replace(/\s+/g, ""),
      );

      return {
        ...delivery,
        type: product?.type,
        sku: product?.sku || "-",
        product: product?.name || "-",
        variant: product?.variant || "-",
      };
    })
    ?.sort((a, b) => {
      if (a.deliveryId === b.deliveryId) {
        return a.product.localeCompare(b.product);
      }

      return 0;
    });

  const dryStockDeliveryProductsDataTable = useDataTable({
    value: formattedDeliveryProducts,
    filter: { initialState: initialFilterState(), mapper: (val) => val },
    table: {
      key: "delivery",
      name: "dryStockDeliveryProducts",
      mapper: (val) => dryStockDeliveryProductsMapper({ val }),
      columns: dryStockDeliveryProductsColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.dryStockDeliveries}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2
          {...dryStockDeliveriesDataTable.table}
          hideNoSearchResultRender
          tableVersion="v2"
          hidePagination
        />
      </div>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2
          {...dryStockDeliveryProductsDataTable.table}
          hideNoSearchResultRender
          tableVersion="v2"
          hidePagination
        />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsDryStockDeliveries;
